<template>
  <b-card title="Pesquisa por CPF/CNPJ">
    <b-form-group>
      <b-input-group>
       <b-form-input
          v-model="text"
          placeholder="Digite CPF ou CNPJ"
          v-mask="mask"
        />

        <b-input-group-append>
          <b-button variant="primary" :disabled="!text" @click="submitText">
            Buscar
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-card>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    fileUploaded: {
      type: Boolean,
      default: false,
    },
  },
 data() {
  return {
    text: '',
  }
},
computed: {
  mask() {
    const numbers = this.text.replace(/\D/g, '');
    return numbers.length > 11
      ? '##.###.###/####-##'  
      : '###.###.###-##';     
    }
  },
  
  methods: {
    submitText() {
      if (!this.text) return;
      this.$emit("search", this.text);
    },
  },
};
</script>